<template>
  <buttons-group
      :items="items"
      :indexStep="index"
      :disabledAll="disabled"
      @click="getIndex"
  />
</template>

<script>
export default {
  props: {
    index: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      items: ['Quantidade de Beneficiários', 'Quantidade de Cooperados', 'Quantidade de Colaboradores'],
      disabled: true
    }
  },
  methods: {
    getIndex (index) {
      this.$emit('changeButton', index)
    },
    changeDisabled () {
      this.disabled = true
    }
  }
}
</script>

<style scoped>

</style>
